import { ErrorMessage, Form, Formik } from 'formik'
import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import * as Yup from 'yup'
import Loader from '../../../components/Loader'
import ModelComponent from '../../../components/Modal'
import ReactSelect from '../../../components/ReactSelect'
import TextError from '../../../components/TextError'
import { showToast } from '../../../lib/AllGlobalFunction'
import { _status_ } from '../../../lib/AllStaticVariables'
import axiosProvider from '../../../lib/AxiosProvider'
import { _brandCertificateImg_ } from '../../../lib/ImagePath'
import { _exception } from '../../../lib/exceptionMessage'

const AssignBrandToSellerForm = ({
  loading,
  setLoading,
  initVal,
  initialValues,
  setInitialValues,
  fetchData,
  modalShow,
  setModalShow,
  toast,
  setToast,
  allState
}) => {
  const { userInfo } = useSelector((state) => state.user)
  const location = useLocation()
  const SUPPORTED_FORMATS = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'application/pdf'
  ]

  const validationSchema = Yup.object().shape({
    sellerID: Yup.string()
      .test('nonull', 'Please select Seller', (value) => value !== 'undefined')
      .required('Please select Seller'),
    brandId: Yup.string()
      .test('nonull', 'Please select Brand', (value) => value !== 'undefined')
      .required('Please select Brand'),
    status: Yup.string()
      .test('nonull', 'Please select Status', (value) => value !== 'undefined')
      .required('Please select Status'),
    brandCertificate: Yup.mixed()
      .test(
        'fileFormat',
        'File formate is not supported, Please use .jpg/.png/.jpeg format support',
        (value) => {
          if (typeof value === 'string') return true
          else {
            return value && SUPPORTED_FORMATS?.includes(value.type)
          }
        }
      )
      .test('fileSize', 'File must be less than 2MB', (value) => {
        if (typeof value === 'string') {
          return true
        } else return value !== undefined && value && value.size <= 2000000
      })
      .required('Certificate required')
  })

  const onSubmit = async (values, resetForm) => {
    let dataofForm = {
      BrandName: values.brandName,
      BrandId: values.brandId,
      SellerName: values.sellerName,
      SellerID: values.sellerID,
      BrandCertificate: values.brandCertificate?.name
        ? values?.brandCertificate?.name
        : values?.brandCertificate,
      Status: values.status,
      FileName: values.brandCertificate
    }

    if (values?.id) {
      dataofForm = { ...dataofForm, Id: values?.id }
    }

    const submitFormData = new FormData()

    const keys = Object.keys(dataofForm)

    keys.forEach((key) => {
      submitFormData.append(key, dataofForm[key])
    })

    try {
      setLoading(true)

      const response = await axiosProvider({
        method: values?.id ? 'PUT' : 'POST',
        endpoint: `AssignBrandToSeller`,
        data: submitFormData,
        logData: values,
        location: location?.pathname,
        userId: userInfo?.userId,
        oldData: initialValues
      })
      setLoading(false)

      if (response?.data?.code === 200) {
        resetForm({ values: '' })
        setModalShow(false)
        fetchData()
      }
      showToast(toast, setToast, response)
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, setErrors, setTouched, resetForm }) => (
        <Form id='assign-brand-to-seller'>
          <ModelComponent
            show={modalShow}
            className='modal-backdrop'
            modalsize={'md'}
            modeltitle={'Assign Brand To Seller'}
            onHide={() => {
              setModalShow(false)
              resetForm({ values: '' })
            }}
            backdrop={'static'}
            formbuttonid={'assign-brand-to-seller'}
            submitname={!initialValues?.id ? 'Create' : 'Update'}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            formik={{ values, setFieldValue, setErrors, setTouched, resetForm }}
          >
            {loading && <Loader />}
            <div className='row'>
              <div className='col-md-3'>
                <div className='input-file-wrapper m--cst-filetype mb-3'>
                  <label className='form-label required' htmlFor='image'>
                    Certificate
                  </label>
                  <input
                    id='image'
                    className='form-control'
                    name='image'
                    type='file'
                    accept='image/jpg, image/png, image/jpeg'
                    onChange={(event) => {
                      const objectUrl = URL.createObjectURL(
                        event.target.files[0]
                      )
                      if (event.target.files[0].type !== '') {
                        setFieldValue('image', objectUrl)
                      }
                      setFieldValue('brandCertificate', event.target.files[0])
                    }}
                    hidden
                  />
                  {values?.brandCertificate ? (
                    <div className='position-relative m--img-preview d-flex rounded-2 overflow-hidden'>
                      <img
                        src={
                          values?.image?.includes('blob')
                            ? values?.image
                            : `${process.env.REACT_APP_IMG_URL}${_brandCertificateImg_}${values?.brandCertificate}`
                        }
                        alt='Preview Certificate'
                        title={
                          values?.image?.includes('blob')
                            ? values?.brandCertificate?.name
                            : 'Brand Certificate'
                        }
                        className='rounded-2'
                      ></img>
                      <span
                        onClick={(e) => {
                          setFieldValue('image', null)
                          setFieldValue('brandCertificate', null)
                          document.getElementById('image').value = null
                        }}
                      >
                        <i className='m-icon m-icon--close'></i>
                      </span>
                    </div>
                  ) : (
                    <>
                      <label
                        className='m__image_default d-flex align-items-center justify-content-center rounded-2'
                        htmlFor='image'
                      >
                        <i className='m-icon m-icon--defaultpreview'></i>
                      </label>
                    </>
                  )}
                  <ErrorMessage
                    name='brandCertificate'
                    component={TextError}
                    customclass={'cfz-12 lh-sm'}
                  />
                </div>
              </div>
              <div className='col-md-9'>
                <div className='row'>
                  <div className='col-md-12'>
                    <div className='input-select-wrapper mb-3'>
                      <label className='form-label required'>
                        Select Seller
                      </label>
                      <ReactSelect
                        id='sellerID'
                        name='sellerID'
                        value={
                          values?.sellerID && {
                            value: values.sellerID,
                            label: values.sellerName
                          }
                        }
                        isDisabled={initialValues?.id ? true : false}
                        options={allState?.sellerDetails?.map(
                          ({ displayName, userId }) => ({
                            value: userId,
                            label: displayName
                          })
                        )}
                        onChange={(e) => {
                          if (e) {
                            setFieldValue('sellerID', e?.value)
                            setFieldValue('sellerName', e?.label)
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className='col-md-12'>
                    <div className='input-select-wrapper mb-3'>
                      <label className='form-label required'>
                        Select Brand
                      </label>
                      <ReactSelect
                        id='brandId'
                        name='brandId'
                        value={
                          values?.brandId && {
                            value: values.brandId,
                            label: values.brandName
                          }
                        }
                        isDisabled={initialValues?.id ? true : false}
                        options={allState?.brand?.map(({ id, name }) => ({
                          value: id,
                          label: name
                        }))}
                        onChange={(e, option) => {
                          if (e) {
                            setFieldValue('brandId', e?.value)
                            setFieldValue('brandName', e?.label)
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-12'>
                <div className='input-select-wrapper mb-3'>
                  <label className='form-label required'>Select Status</label>
                  <ReactSelect
                    id='status'
                    name='status'
                    value={
                      values?.status && {
                        value: values.status,
                        label: values.status
                      }
                    }
                    options={_status_}
                    onChange={(e) => {
                      if (e) {
                        setFieldValue('status', e?.value)
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </ModelComponent>
        </Form>
      )}
    </Formik>
  )
}

export default AssignBrandToSellerForm
